import { CloneJobWatcher } from '@/Domain/components/Settings/ai/CloneJobWatcher';
import { useCloneJobsStore } from '@/Domain/store/cloneJobs.store';

/**
 * Every queued copy currently in flight, watched from the application shell.
 *
 * Not from the switcher that queues them: on mobile that lives inside the
 * sidebar Sheet, which unmounts when closed and would take the polling, the
 * agent-list refresh and the completion toast with it.
 */
export const CloneJobWatchers = () => {
  const pendingJobIds = useCloneJobsStore((state) => state.pendingJobIds);
  const forgetJob = useCloneJobsStore((state) => state.forgetJob);

  return (
    <>
      {pendingJobIds.map((jobId) => (
        <CloneJobWatcher key={jobId} jobId={jobId} onSettled={forgetJob} />
      ))}
    </>
  );
};
